import React, { forwardRef } from 'react'
import { urlRegexValidator } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import ContrastSecurityMappingForm from './ContrastSecurityMappingForm';

function ContrastSecurityCredentialsForm(props, ref){

    const fields = [{
        name: "apiEndpoint",
        label: "API Endpoint",
        required: true,
        rules:[urlRegexValidator],
    },{
        name: "apiKey",
        label: "Api Key",
        required: true
    },{
        name: "username",
        label: "Username",
        required: true
    },{    
        name: "serviceKey",
        label: "Service Key",
        required: true
    },{
        name: "orgId",
        label: "Organisation Id",
        required: true
    }]
    
    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            versionField={false}
            MappingForm={ContrastSecurityMappingForm}
        />
    )
}

export default forwardRef(ContrastSecurityCredentialsForm);